import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import { errorMessage } from "@/lib/errors";
import * as loadsApi from "@/services/api/loads";
import type { LoadListParams } from "@/services/api/loads";

export function useLoads(params: LoadListParams = {}) {
  return useQuery({
    queryKey: ["loads", params],
    queryFn: () => loadsApi.listLoads(params),
  });
}

export function useTransitionLoad() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, target_status }: { id: number; target_status: string }) =>
      loadsApi.transitionLoad(id, target_status),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["loads"] });
    },
    onError: (error) => {
      toast.error(errorMessage(error));
    },
  });
}

export function useUpdateLoad() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      data,
      ifMatch,
    }: {
      id: number;
      data: loadsApi.LoadUpdate;
      ifMatch: string | number;
    }) => loadsApi.updateLoad(id, data, ifMatch),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["loads"] });
    },
  });
}
